export const geographyColumns = [
  {
    dataField: 'name',
    text: 'geography.name',
    disableSort: true,
  },
  {
    dataField: 'description',
    text: 'geography.description',
    disableSort: true,
  },
  {
    dataField: 'type',
    text: 'geography.type',
    disableSort: true,
  },
  {
    dataField: 'capacity',
    text: 'geography.capacity',
    disableSort: true,
  },
  {
    dataField: 'season',
    text: 'geography.season',
    disableSort: true,
  },
  {
    dataField: 'time_start',
    text: 'geography.time_start',
    disableSort: true,
  },
  {
    dataField: 'time_end',
    text: 'geography.time_end',
    disableSort: true,
  },
];
